import { useEffect, useState } from "react";
import type { TournamentState } from "../../../../engine/types";

/** Re-render every `ms` so a countdown moves. The time itself always comes from t.now(). */
export function useTick(ms: number): void {
  const [, setN] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setN((x) => x + 1), ms);
    return () => clearInterval(id);
  }, [ms]);
}

/** Ms left in the current phase, frozen while paused. Null between rounds. */
export function msLeft(state: TournamentState, now: number): number | null {
  const { phaseEndsAt, pausedAt } = state.clock;
  if (phaseEndsAt === null) return null;
  return Math.max(0, phaseEndsAt - (pausedAt ?? now));
}

export function mmss(ms: number): string {
  const total = Math.ceil(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function loadJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function saveJson(key: string, value: unknown): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage can be unavailable; the screen still works from memory
  }
}
